import { useLocale } from '@gov-nx/core/service';
import {
	DaysTillDeleteThresholds,
	type UseDaysTillDeleteProps,
	type UseDaysTillDeleteReturn,
} from './useDaysTillDelete.types';
import { isNumber } from '@gov-nx/core/types';
import { getDaysTillDeleteInfo } from './getDaysTillDeleteInfo';

export const useDaysTillDelete = ({
	daysTillDelete,
	code,
}: UseDaysTillDeleteProps): UseDaysTillDeleteReturn => {
	const { t } = useLocale(code);
	const daysTillDeleteSafe = daysTillDelete ?? 0;

	const isDaysTillDeleteVisible = isNumber(daysTillDelete);
	const daysTillDeleteInfo = getDaysTillDeleteInfo(daysTillDeleteSafe, t);

	return {
		isDaysTillDeleteVisible,
		isLessThan10Days: daysTillDeleteSafe < DaysTillDeleteThresholds.DAYS10,
		daysTillDeleteText: daysTillDeleteInfo.value,
		daysTillDeletePrefix: daysTillDeleteInfo.prefix,
	};
};
